module.exports = __webpack_public_path__ + "img/STAND-FPD-detail.3991720d.png";